export const getToken = () => {
  return document.querySelector('meta[name=csrf-token]').content;
};